const template = require('./widget.html');
require('./widget.scss');
var logger = require('../../common/logging.config');


// used to create unique id
var index = 0;

class WidgetController {

	
	constructor($rootScope, $scope, $compile, $element, $translate, tenantRegistryService, $templateCache, $timeout, homepageUtil, x1UiPopoverConstants) {
		this.$rootScope = $rootScope;
		this.$templateCache = $templateCache;
		this.$translate = $translate;
		this.$timeout = $timeout;
		this.homepageUtil = homepageUtil;
		this.x1UiPopoverConstants = x1UiPopoverConstants;
		this.popoverTitle = 'Preferences';
		
		this.$onInit = () => {
			if (typeof this.wcomponent !== 'undefined' && this.wcomponent.trim().length > 0) {
				// create new specified angular component and append it to the widget body element
				var newElement = $compile("<"+this.wcomponent+"></"+this.wcomponent+">")($scope);
				angular.element($element[0].querySelector('.widget-body')).append(newElement);
			}
			
			this.hasPreferences = false;
			this.hasTitle = false;
			this.wTitle = this.wtitle;
			if (typeof this.wtitle !== 'undefined') {
				this.hasTitle = this.wtitle.length > 0;
				this.hasSubtitle = this.wsubtitle.length > 0;
				this.hubName = "";
				// lookup hub tenant name for widget that needs it in title
				if (this.wcomponent === 'hub-usage') {
					/*
					// comment this out until next release when displayable tenant name will be provided
					// 
					if (isHubTenantNameSupported) {
						tenantRegistryService.getTenantInformation().then(
							(data) => {
								this.hubName = data.name;
							},
							(error) => {
								logger.error('Error retrieving tenant name from server: ' + error);
							}
						);
					}
					else { */
						this.wTitle = "Content hub usage";
					//}
				}
				else if (this.wcomponent === 'search') {
					// set screen reader label for non-titled Search widget
					this.wTitle = "ariaSearchBox";
				}
				else if (this.wcomponent === 'publishing-at-a-glance') {
					// construct preferences popover
					this.$templateCache.put('publishingAtAGlancePreferences', '<publishing-at-a-glance-preferences></publishing-at-a-glance-preferences>');
		            this.popover = {
		                "title": this.popoverTitle,
		                "placement": "bottom-left",
		                "contentTemplate": "publishingAtAGlancePreferences"
		            };
					// add preferences icon to widget title
					this.hasPreferences = true;
				}
			}
			
			this.isCollapsed = false;
			this.index = index++;
			this.ExpandOrCollapse = this.$translate.instant("Collapse");

			// set the translated title on the prefs popover if we have one
			if (this.hasPreferences) {
				this.$translate([this.popoverTitle]).then(nls => {
					this.popover.title = nls[this.popoverTitle];
				});
			}
		};

		// listen for x1 popover close event to restore focus to the prefs button
		$scope.$on(this.x1UiPopoverConstants.CLOSED_POPOVER, () => {
			$scope.$evalAsync(() => {
				const prefsButton = document.querySelector("#" + this.wcomponent + "-prefs");
				if (prefsButton) {
					prefsButton.focus();
				}
			});
		});

		// listen for preferences open event to add a11y label (workaround for x1-popover shortcomings)
		const handler = $rootScope.$on('preferences-open', (event, payload) => {
			const popoverDialog = angular.element(document.querySelector("div.widget-buttons>div.x1-ui-popover"));
			if (popoverDialog) {
				popoverDialog.attr('aria-labelledby', 'x1PopoverTitle');
				
				const popoverInclude= angular.element(document.querySelector("div.widget-buttons>div.x1-ui-popover>ng-include"));
				if (popoverInclude) {
					popoverInclude.attr('aria-labelledby', 'x1PopoverTitle');
				}
			}
		});
		$scope.$on('$destroy', handler);
		
	}
	
	resize(event) {
		// this routine is called for both keypress and mouse events
		const keycode = this.homepageUtil.getKeyCode(event);
		if (typeof keycode !== 'undefined') {
			// a key was pressed, only accept enter or space 
			if (keycode === 13 || keycode === 32) {
				event.preventDefault();
			}
			else {
				return;
			}
		}
		
		this.isCollapsed = !this.isCollapsed;
		this.ExpandOrCollapse = this.isCollapsed?this.$translate.instant("Expand"):this.$translate.instant("Collapse");
	}
	
	openPreferences(event) {
		// only called for keypress events
		// on keypress event, only accept enter or space
		const keycode = this.homepageUtil.getKeyCode(event);
		if (typeof keycode !== 'undefined' && (keycode === 13 || keycode === 32)) {
			const target = event.target;
			event.preventDefault();
            // wait until after current digest cycle
			this.$timeout(() => { 
				target.click();
			}, 200);
		}
	}
};

module.exports = {
	templateUrl: template,
	bindings: {
		wtitle: "@",
		wsubtitle: "@",
		wcomponent: "@"
	},
	transclude: true,
	controller: ['$rootScope', '$scope', '$compile', '$element', '$translate', "tenantRegistryService", "$templateCache", "$timeout", "homepageUtil", "x1.ui.popover.events", WidgetController]
};



// WEBPACK FOOTER //
// ./app/components/widget/widget.component.js